import { getBackendUrl } from "../lib/utils";
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { getImageUrl } from '../lib/utils';

const About = () => {
  const [data, setData] = useState({
    title: "Hakkımızda",
    subtitle: "S.S. İkitelli - Silivri Toplu İşyeri Yapı Kooperatifi",
    paragraphs: [
      "2023 yılında kurulan S.S. İkitelli - Silivri Toplu İşyeri Yapı Kooperatifi, bölgede iş dünyasının ihtiyaçlarına yönelik modern ve kapsamlı üretim-ticaret alanları oluşturmayı hedeflemiştir.",
      "Kooperatifimiz Silivri’de yer alan geniş bir arazi üzerinde proje geliştirme süreçlerine başlamıştır. Amacımız, üyelerimize çağdaş, altyapısı güçlü ve geleceğin ticari standartlarına uygun çalışma ortamları sunmaktır."
    ],
    images: [
      "/images/renders_hero/hero5.jpg",
      "/images/renders/render1.jpg"
    ]
  });

  useEffect(() => {
    const backendUrl = getBackendUrl();
    axios.get(`${backendUrl}/api/settings`)
      .then(res => {
        if (res.data.about_page) {
          setData(res.data.about_page);
        }
      })
      .catch(console.error);
  }, []);

  return (
    <div className="pt-32 pb-24 min-h-screen bg-slate-50">
      <div className="container mx-auto px-6 max-w-5xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8">{data.title}</h1>
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-100">
            <h2 className="text-2xl font-semibold text-slate-800 mb-6">{data.subtitle}</h2>
            <div className="prose prose-lg text-slate-600 max-w-none space-y-6">
              {data.paragraphs && data.paragraphs.map((p, idx) => (
                <p key={idx}>{p}</p>
              ))}
              
              <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
                {data.images && data.images.map((img, idx) => (
                  <div key={idx} className="rounded-xl overflow-hidden aspect-video relative">
                    <img
                      src={getImageUrl(img)}
                      alt={`Facility Render ${idx + 1}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default About;
